import { Navigate, Outlet, useParams } from 'react-router-dom';

import { usePermissions } from 'hooks/usePermissions';
import type { PermitAction } from 'hooks/usePermissions';

type Props = {
  requiredPermission: PermitAction;
};

export const RequirePermission = ({ requiredPermission }: Props) => {
  const { organisationId } = useParams();
  const { isPermitted } = usePermissions();

  if (isPermitted(requiredPermission)) {
    return <Outlet />;
  } else {
    return <Navigate to={`/org/${organisationId}`} replace />;
  }
};
